import { forwardRef } from "react";
import { Skeleton, Select, SelectProps } from "@mui/material";

type LoadingSelectProps = {
  isLoading?: boolean;
} & SelectProps;

const LoadingSelect = forwardRef<HTMLInputElement, LoadingSelectProps>(
  (props, ref) => {
    const { isLoading, ...rest } = props;
    if (isLoading) {
      return (
        <Skeleton variant="rectangular" sx={{ borderRadius: 1 }} height={48} />
      );
    }

    return <Select inputRef={ref} {...rest} />;
  }
);

export default LoadingSelect;
